import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';



function Login({ login }) {


  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);


  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate()

  const [Authenticated, setAuthenticated] = useState(null);


  useEffect(()=>{
    axios.get('/api/login/status').then(function(res){
      if(res.data){
        navigate('/admin')
      }
    })

  }, [])

  const handleSubmit = async (event) => {

    try {

      const response = await axios.put('/api/login/authenticate', { 
        username: username, 
        password: password
      
      });

      if(response.data.authenticated){
        window.open('/admin', '_self')
      }else{
        setAuthenticated(false)
      }
    } catch (error) {
      console.error(error);
    }
  };

  


  
  return (

    <>

    <div onSubmit={handleSubmit} style={{transform: "translate(-50%, -50%)", left: "50%", top: "50%", position: "absolute", width: '300px', display: 'flex', flexDirection: 'column', gap: '20px'}}>

      <input maxlength="200" placeholder={'Login'} style={{}} onChange={(e) => setUsername(e.target.value)} onKeyDown={(e)=>{if(e.key === 'Enter'){handleSubmit()}}}/> 
      <div style={{position: 'relative', float: 'left'}}>
        <input maxlength="200" type={showPassword ? "text" : "password"} placeholder={/*parse(CurrentLanguage.password)*/'Password'} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e)=>{if(e.key === 'Enter'){handleSubmit()}}}/> 
        <img style={{background: '#fff', padding: '9px', height: '20px', width: '20px', position: 'absolute', right: '-38px', top: '0', cursor: 'pointer'}} src={showPassword ? './eye_open.png' : './eye_closed.png'} onClick={()=>{setShowPassword(!showPassword)}}/>
      </div>

      <div class="button" style={{textAlign: 'center', alignSelf: 'center'}} onClick={()=>{handleSubmit()}}>→</div>
      {Authenticated === false ?
        <p style={{color: 'red', textAlign: 'center'}}>{'Invalid credentials'}</p>
      : null}

      
    </div>



    
    </>



  );




};

export default Login;